import { ProfileInformationStep } from 'pages/employee-reviews/complete/steps';
import { profileInformationTopicKey } from 'pages/employee-reviews/shared';
import { EmployeeService } from 'services';
import {
    applyLoadedRecord,
    createEditableTopicState,
    getEditableTopicGating,
    isEditableTopicDirty
} from './editableTopicState';

// The Profile Information topic: the employee's own profile fields, read and written through the
// employee record's existing endpoints.
export const profileInformationTopic = {
    key: profileInformationTopicKey,
    stepTitle: "Profile Information",
    Step: ProfileInformationStep,
    createInitialState: createEditableTopicState,
    load: (employeeId) => EmployeeService.getEmployee(employeeId),
    loadFailureMessage: "Failed to get the employee profile. Please refresh the page.",
    applyLoaded: (response) => applyLoadedRecord(response),
    getGating: (state) => getEditableTopicGating(
        state,
        "profile",
        "The employee's profile information could not be loaded. Please refresh the page before continuing."
    ),
    isDirty: isEditableTopicDirty,
    getComment: (state) => state.comment
};
